var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLifeEvidence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vector",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "M32.231,36.432L18.563,36.432",
    strokeWidth: 1.5,
    stroke: "#24427a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path_0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "M11.877,34.226V12.346a1.978,1.978 0,0 1,1.978 -1.978H51.788a1.978,1.978 0,0 1,1.978 1.978v12.73",
    strokeWidth: 1.5,
    stroke: "#24427a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path_1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "M11.877,26.628 L5.914,29.063A5.51,5.51 0,0 0,2.306 32.67,20.013 20.013,0 0,1 1.5,34.752",
    strokeWidth: 1.5,
    stroke: "#24427a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path_2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "M8.993,36.506l4.192,-3.314a3.667,3.667 0,0 1,5.393 0.953,2.158 2.158,0 0,1 -0.507,2.83c-2.473,1.938 -5.077,4.446 -5.077,4.446s-1.819,7.565 -8.928,8.211",
    strokeWidth: 1.5,
    stroke: "#24427a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path_3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "M16.263,14.915h12.918v13.443h-12.918z",
    strokeWidth: 1.5,
    stroke: "#24427a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path_4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "M26.353,23.66l-2.366,-1.216a2.688,2.688 0,1 0,-2.53 0L19.091,23.66a1.256,1.256 0,0 0,-0.683 1.117v3.581h8.627V24.777A1.255,1.255 0,0 0,26.353 23.66Z",
    strokeWidth: 1.5,
    stroke: "#24427a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path_5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "M33.805,15.329L39.565,15.329",
    strokeWidth: 1.5,
    stroke: "#24427a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path_6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "M33.805,19.627L42.851,19.627",
    strokeWidth: 1.5,
    stroke: "#24427a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path_7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "M33.805,24.692L42.034,24.692",
    strokeWidth: 1.5,
    stroke: "#24427a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path_8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#24427a",
    d: "M48.5,14.12l0.615,1.493 1.244,0.019a0.306,0.306 0,0 1,0.207 0.537l-1.1,0.944 0.576,1.386a0.326,0.326 0,0 1,-0.47 0.4l-1.433,-0.838 -1.458,0.792a0.327,0.327 0,0 1,-0.458 -0.416l0.62,-1.366 -1.064,-0.979a0.305,0.305 0,0 1,0.222 -0.53l1.244,0.02 0.664,-1.472A0.329,0.329 0,0 1,48.5 14.12Z",
    id: "path_9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#00000000",
    d: "M55.048,37.831A8.743,8.743 0,1 1,49.5 29.687",
    strokeWidth: 1.5,
    stroke: "#24427a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path_10"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#24427a",
    d: "M57.8,30.64a0.5,0.5 0,0 0,-0.277 -0.868c-1.416,-0.166 -4.27,0.141 -7.838,3.907a48.741,48.741 0,0 0,-3.6 4.341c-0.8,-0.816 -3.417,-3.226 -4.765,-1.789a0.5,0.5 0,0 0,-0.035 0.642c0.69,0.916 2.791,3.715 3.426,4.694a1.7,1.7 0,0 0,2.888 0,44.426 44.426,0 0,1 4.453,-5.523C53.282,34.748 56.405,31.9 57.8,30.64Z",
    id: "path_11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLifeEvidence);
export default __webpack_public_path__ + "static/media/ic_life_evidence.b9c72f3b50f12fd40d9090bdfdc06884.svg";
export { ForwardRef as ReactComponent };